import React, { memo, useState } from 'react'
import { SxProps, Theme, useMediaQuery } from '@mui/material'
import { t } from 'i18next'
import { useImpersonation } from '../../../context/impersonationContext'
import ContainedButton from '../../../components/common/buttons/containedButton'

interface ImpersonateButtonProps {
  auth0Id?: string
  isLoading?: boolean
  sx?: SxProps<Theme>
}

const ImpersonateButton: React.FC<ImpersonateButtonProps> = memo(({ 
  auth0Id,
  isLoading = false,
  sx
}) => {
  const { startImpersonation, canImpersonate } = useImpersonation()
  const [isImpersonating, setIsImpersonating] = useState(false)
  const isMobile = useMediaQuery('(max-width:1000px)')

  const handleImpersonateClick = async () => {
    try {
      if(!auth0Id) {
        throw new Error('ID utilisateur invalide pour l\'endossement d\'identité.')
      }
      setIsImpersonating(true)
      
      await startImpersonation(auth0Id)
    } catch (error) {
      throw new Error(`Échec de l'endossement d'identité: ${error instanceof Error ? error.message : 'Erreur inconnue'}`)
    } finally {
      setIsImpersonating(false)
    }
  }

  return (
    <ContainedButton
      handleClick={handleImpersonateClick}
      disabled={isLoading || isImpersonating || !canImpersonate() || !auth0Id}
      title={auth0Id ? (isImpersonating ? 'En cours...' : t('pages.personification.buttons.impersonate')) : 'ID utilisateur manquant'}
      sx={{
        minWidth: isMobile ? '80px' : '140px',
        height: '36px',
        fontSize: isMobile ? '12px' : '14px',
        ...sx
      }}
    />
  )
})

ImpersonateButton.displayName = 'ImpersonateButton'

export default ImpersonateButton
